import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { AppBar, Box, IconButton, Toolbar, Tooltip } from '@mui/material';
import { PropsWithChildren } from 'react';
import { BelnickLogo } from '../logos';

export function PublicHeader({ children }: PropsWithChildren<{}>) {
    const openSupportPortal = () =>
        window.open(
            'https://insight2profit.atlassian.net/servicedesk/customer/portal/10',
            '_blank',
            'noopener,noreferrer'
        );

    return (
        <AppBar position='static'>
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box></Box>
                <Box justifyContent='center'>
                    <BelnickLogo />
                </Box>
                <Box justifyContent='end'>
                    <Tooltip title='Customer Support'>
                        <IconButton color='inherit' onClick={openSupportPortal} size='large'>
                            <HelpOutlineOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Toolbar>
        </AppBar>
    );
}
